import { HStack, Text } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import { isMessageThreadReadOnly } from "modules/utils/Functions";
import colors from "app/colors";
import { HelpIcon, ReadOnlyIcon } from "modules/icons";
import { MessageThreadFragment } from "gql/graphql";
import CircularIconButton from "modules/_shared/buttons/circular-icon-button";
import { useOverlay } from "modules/providers/overlay-provider";
import { MODAL_TYPE } from "modules/providers/overlay-provider/overlay-provider";
import useRemovedFromThread from "modules/hooks/use-removed-from-thread";

interface IProps {
  messageThread: MessageThreadFragment;
}

const MessageThreadReadOnlyHeader = ({ messageThread }: IProps) => {
  const { openModal } = useOverlay();

  const _isMessageThreadReadOnly = isMessageThreadReadOnly(messageThread);
  const { isMeRemoved } = useRemovedFromThread(messageThread);

  const onReadOnlyHelpClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      openModal({
        type: MODAL_TYPE.READ_ONLY_INFO,
      });
    },
    [openModal],
  );

  if (!_isMessageThreadReadOnly || isMeRemoved) {
    return null;
  }

  return (
    <HStack
      py={1}
      px={2}
      bg={colors.yellow20}
      h={6}
      w="full"
      alignItems="flex-start"
    >
      <ReadOnlyIcon fill={colors.blackSecondary} boxSize={4} />
      <Text fontWeight={400} fontSize={12} color={colors.blackSecondary}>
        This thread is read-only
      </Text>
      <CircularIconButton
        size="xxs"
        icon={<HelpIcon boxSize={4} fill={colors.gray40} />}
        aria-label="Read only info"
        onClick={onReadOnlyHelpClick}
      />
    </HStack>
  );
};

export default memo(MessageThreadReadOnlyHeader);
